.secondaryText {
  overflow: hidden;
  text-overflow: ellipsis;
}

.buttonGroup {
  width: 100%;
}
